
export default {
    namespaced: true,
    state: {
        displayNavDrawer: false,
        loadingRoute: false
    },
  
    getters: {
  
    },
  
    mutations: {
        toggleDisplayNavDrawer (state) {
            state.displayNavDrawer = !state.displayNavDrawer
        },
        hideNavDrawer (state) {
            state.displayNavDrawer = false
        },
        displayNavDrawer (state) {
            state.displayNavDrawer = true
        },
        setDisplayNavDrawer (state, value) {
            state.displayNavDrawer = value
        },
        setLoadingRoute (state, value) {
            state.loadingRoute = value
        }
    },
  
    actions: {
  
    }
}